import React from "react";
import PropTypes from "prop-types";

export default function FeaturesGrid({
  title = "Our other features",
  features = [],
  loading,
  limit = 4,
}) {
  const visible = features.slice(0, limit);

  if (loading) {
    return (
      <div className="card-soft p-4 features-card">
        <div className="skeleton w-100 h-100" />
      </div>
    );
  }

  return (
    <div className="card-soft p-2 features-card">
      <h6 className="fw-bold mb-1">{title}</h6>
      <div className="features-tile-grid">
        {visible.map((f) => (
          <div key={f.id} className="feature-tile">
            <div
              className="feature-tile-icon"
              dangerouslySetInnerHTML={{ __html: f.svg }}
            />
            <span className="feature-tile-label">{f.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

FeaturesGrid.propTypes = {
  title: PropTypes.string,
  features: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      svg: PropTypes.string,
    }),
  ),
  loading: PropTypes.bool,
  limit: PropTypes.number,
};
